import { render, staticRenderFns } from "./TestimonialsSection.vue?vue&type=template&id=24efb4ad&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsSection.vue?vue&type=style&index=0&id=24efb4ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24efb4ad",
  null
  
)

export default component.exports